import { render, staticRenderFns } from "./SignUpList.vue?vue&type=template&id=570ff5bd&scoped=true&lang=pug"
import script from "./SignUpList.vue?vue&type=script&lang=js"
export * from "./SignUpList.vue?vue&type=script&lang=js"
import style0 from "./SignUpList.vue?vue&type=style&index=0&id=570ff5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ff5bd",
  null
  
)

export default component.exports